import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiCheck, FiStar, FiZap, FiHeart, FiEye, FiRefreshCw, FiMapPin, FiZap as FiZapIcon, FiAward } from 'react-icons/fi';
import Button from '../components/ui/Button';

const plans = [
  {
    name: 'VIBE Plus',
    monthly: '₹199',
    yearly: '₹1,499',
    yearlyPer: '₹125/mo',
    color: '#3B82F6',
    features: [
      { icon: '♾️', text: 'Unlimited Likes', free: false },
      { icon: '👀', text: 'See Who Likes You', free: false },
      { icon: '⭐', text: '5 Super Likes/day', free: false },
      { icon: '🔄', text: 'Rewind Swipes', free: false },
      { icon: '💬', text: 'Priority Support', free: false },
    ]
  },
  {
    name: 'VIBE Gold',
    monthly: '₹499',
    yearly: '₹3,499',
    yearlyPer: '₹292/mo',
    color: '#FF3D71',
    popular: true,
    features: [
      { icon: '♾️', text: 'Unlimited Likes', free: false },
      { icon: '👀', text: 'See Who Likes You', free: false },
      { icon: '⭐', text: 'Unlimited Super Likes', free: false },
      { icon: '🔄', text: 'Rewind Swipes', free: false },
      { icon: '📍', text: 'Change Location', free: false },
      { icon: '🤖', text: 'Advanced Compatibility', free: false },
      { icon: '🔥', text: 'Priority Profile', free: false },
    ]
  },
  {
    name: 'VIBE Platinum',
    monthly: '₹999',
    yearly: '₹6,999',
    yearlyPer: '₹584/mo',
    color: '#F59E0B',
    features: [
      { icon: '♾️', text: 'Everything in Gold', free: false },
      { icon: '🚀', text: 'Unlimited Boosts', free: false },
      { icon: '👑', text: 'Priority in Discovery', free: false },
      { icon: '💌', text: 'Message Before Matching', free: false },
      { icon: '🏅', text: 'Exclusive Badge', free: false },
    ]
  }
];

const Premium = () => {
  const navigate = useNavigate();
  const [billing, setBilling] = useState('yearly');
  const [selectedPlan, setSelectedPlan] = useState(1);

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 40 }}>
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#A1A1AA', cursor: 'pointer' }}>
          <FiArrowLeft size={22} />
        </button>
      </div>

      <div style={{ textAlign: 'center', padding: '0 20px 24px' }}>
        <div style={{
          width: 72, height: 72, borderRadius: 20, margin: '0 auto 16px',
          background: 'linear-gradient(135deg, rgba(255,61,113,0.15), rgba(139,92,246,0.15))',
          border: '1px solid rgba(255,61,113,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <FiAward size={32} style={{ color: '#FF3D71' }} />
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>
          Unlock Your Full <span style={{ background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>VIBE</span>
        </h1>
        <p style={{ fontSize: 14, color: '#71717A', maxWidth: 300, margin: '0 auto' }}>Get more matches, more dates, more connections</p>
      </div>

      {/* Billing toggle */}
      <div style={{
        display: 'flex', margin: '0 20px 24px', padding: 3, borderRadius: 12,
        background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)',
      }}>
        {[{ id: 'monthly', label: 'Monthly' }, { id: 'yearly', label: 'Yearly', badge: 'SAVE 40%' }].map(b => (
          <button key={b.id} onClick={() => setBilling(b.id)} style={{
            flex: 1, padding: '12px', borderRadius: 10, border: 'none',
            background: billing === b.id ? 'rgba(255,61,113,0.12)' : 'transparent',
            color: billing === b.id ? '#FF3D71' : '#71717A',
            fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
            transition: 'all 0.2s',
          }}>
            {b.label}
            {b.badge && <span style={{ fontSize: 9, padding: '2px 6px', borderRadius: 4, background: '#22C55E20', color: '#22C55E', fontWeight: 700 }}>{b.badge}</span>}
          </button>
        ))}
      </div>

      {/* Plans */}
      <div style={{ padding: '0 16px' }}>
        {plans.map((plan, i) => (
          <div key={i} onClick={() => setSelectedPlan(i)} style={{
            padding: '20px', borderRadius: 20, marginBottom: 12, cursor: 'pointer',
            background: selectedPlan === i ? `${plan.color}08` : 'rgba(255,255,255,0.03)',
            border: `1.5px solid ${selectedPlan === i ? plan.color + '40' : 'rgba(255,255,255,0.04)'}`,
            position: 'relative', transition: 'all 0.2s',
          }}>
            {plan.popular && (
              <div style={{
                position: 'absolute', top: -10, left: 20, padding: '3px 10px',
                background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
                borderRadius: 6, fontSize: 10, fontWeight: 700, color: 'white',
              }}>MOST POPULAR</div>
            )}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4 }}>
              <span style={{ fontSize: 32, fontWeight: 800, color: plan.color }}>
                {billing === 'monthly' ? plan.monthly : plan.yearly}
              </span>
              <span style={{ fontSize: 13, color: '#52525B' }}>/ {billing === 'monthly' ? 'mo' : 'yr'}</span>
            </div>
            {billing === 'yearly' && (
              <p style={{ fontSize: 12, color: '#22C55E', marginBottom: 12 }}>{plan.yearlyPer} billed annually</p>
            )}
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{plan.name}</h3>
            {plan.features.map((f, j) => (
              <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <span style={{ fontSize: 14 }}>{f.icon}</span>
                <span style={{ fontSize: 13, color: '#A1A1AA' }}>{f.text}</span>
              </div>
            ))}
            {selectedPlan === i && (
              <div style={{ position: 'absolute', top: 20, right: 20, width: 22, height: 22, borderRadius: 11,
                background: plan.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FiCheck size={14} style={{ color: 'white' }} />
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{ padding: '16px 20px 0' }}>
        <Button fullWidth size="lg">
          Get {plans[selectedPlan].name} — {billing === 'monthly' ? plans[selectedPlan].monthly : plans[selectedPlan].yearly}/{billing === 'monthly' ? 'mo' : 'yr'}
        </Button>
        <p style={{ textAlign: 'center', fontSize: 11, color: '#52525B', marginTop: 12 }}>
          Cancel anytime. Payment charged to your account.
        </p>
      </div>
    </div>
  );
};

export default Premium;
